import { useContext, useEffect, useState } from 'react';
import styles from './TopBanner.module.css';
import stylesMobile from './TopBannerMobile.module.css';

import SideMenu from './SideMenu';
import { Link, useLocation } from 'react-router-dom';
import ConnUrls from '../Connections/ConnectURL';
import { TheOrderContext } from '../Contexts/TheOrder_Context';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../Contexts/User_Context';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import LogOrRegPagePop from '../PopUps/LogOrRegPagePop';
import ClientDetailsPop from '../PopUps/ClientDetailsPop';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import { PersonAddOutlined } from '@mui/icons-material';
import { MasterContext } from '../Contexts/Master_Context';

const TopBanner = (props) => {
    const { theOrder } = useContext(TheOrderContext);
    const [mastercon, setMastercon] = useContext(MasterContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [thePopUp, setThePopUp] = useState("");
    const [currentStyle, setCurrentStyle] = useState(mobiOrNot ? stylesMobile : styles);
    const [showConnectUser, setShowConnectUser] = useState(false)
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const refreshUser = async () => {
            await UserEffectFunction();
        };
        refreshUser();
        setLoading(false)
    }, []);


    useEffect(() => {
    }, [theOrder]);

    const goShopingcart = () => {
        navigate(`/shopCrt`);
    }

    const popConect = () => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                title={""}
                noLineStart={true}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                theInsideComp={
                    <LogOrRegPagePop
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        parentCLose={() => setThePopUp()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                        connectWithNumber={() => { setThePopUp(); }}
                        heads={["תמצאו כאן את מגשי", "האירוח הטובים ביותר"]}
                    />
                } />
        )
    }


    const clientDetails = () => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                title={user.firstName + " " + user.lastName}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                parentCLose={() => setThePopUp()}
                theInsideComp={
                    <ClientDetailsPop
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        parentCLose={() => props.parentCLose()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                    />
                } />)
    }

    return (
        !loading &&
        <div className={currentStyle.topBanner}>
            <div className={currentStyle.goldTopLine}></div>
            <div className={`${currentStyle.topBannerInItems}`}>
                <div className={`onRight`}>
                    <SideMenu />
                </div>

                <div className={`${currentStyle.websiteLogo} onLeft`}>
                    <Link className={"noDecoration"} to="/">
                        <img className={currentStyle.websiteLogoImg}
                            src={`${ConnUrls.servMediasUrl}${!mobiOrNot ? mastercon?.logoDesktop : mastercon?.webSiteLogo}`}
                            alt="" />
                    </Link>
                </div>

                {/* Conditionally hide the cart icon if the current URL is /shopCrt */}
                <div className={`${currentStyle.floutingCart} ${location.pathname === '/shopCrt' ? currentStyle.hideCartIcon : (theOrder.items?.length > 0 ? currentStyle.showCartIcon : currentStyle.hideCartIcon)}`}>
                    <div className={`${currentStyle.contactIcons}`}>
                        <div className={`${currentStyle.animate__pulseToIN}
                                 animate__animated animate__faster onRight pointing`} onClick={() => goShopingcart()}>
                            <img className={currentStyle.shopCartIcon}
                                src={`${ConnUrls.PermanentImages}/shponCartIcon.png`}
                                alt="" />
                            {theOrder.items?.length > 0 &&
                                <span className={currentStyle.shopCartCount}>{theOrder.items.length}</span>
                            }
                        </div>
                    </div>
                </div>
                {user?.firstName && user?.firstName !== "" ?
                    <div className={`${currentStyle.displayUsrNamePlace} bold pointing`}>
                        <div
                            className={`${currentStyle.iconINPlace} ${showConnectUser ? currentStyle.showWithText : ""}`}
                            onClick={() => setShowConnectUser(!showConnectUser)}
                        >
                            <div className={"onRight"}><PersonAddOutlined /></div>
                            {showConnectUser && (
                                <div className={currentStyle.userNamText} onClick={() => { clientDetails(); setShowConnectUser(!showConnectUser) }}>
                                    היי, {user.firstName}
                                </div>
                            )}
                        </div>
                    </div>


                    :

                    <div className={`${currentStyle.displayUsrNamePlace} bold pointing`}>

                        <div
                            className={`${currentStyle.iconINPlace} ${showConnectUser ? currentStyle.showWithText : ""}`}
                            onClick={() => setShowConnectUser(!showConnectUser)}
                        >
                            <div className={"onRight"}><PersonAddOutlined /></div>
                            {showConnectUser && (
                                <div className={`${currentStyle.userNamText} onLeft`} onClick={() => { popConect(); setShowConnectUser(!showConnectUser) }}>
                                    התחברות
                                </div>
                            )}

                        </div>



                    </div>

                }
            </div>
            {thePopUp}
        </div>
    );
}

export default TopBanner;
